import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';

import { SummaryContainer } from './css';

import FleetTracker from './fleetTracker';
import AssetTracker from './assetTracker';
import VideoTelematics from './videoTelematics';

const SummaryTracker = ({
  rateplanList,
  hasAdditonalServices,
  ratePlans,
  additionalServices,
  addons,
  hardware,
  vehicleInfo
}) => {
  const [hardwareModel, setHardwareModel] = useState();
  const [hardwareList, setHardwareList] = useState();
  const [tracker, setTracker] = useState({
    fleetTrackerRateplanTotal: 0,
    assetTrackerRateplanTotal: 0,
    videoTelematicsTracker: 0,
    ...(hasAdditonalServices && { additionalServicesTotal: 0 }),
    addonsTotal: 0,
    vehiclesTotal: 0
  });

  useEffect(() => {
    const hardwareTotalList = rateplanList.reduce((acc, current) => {
      if (!_.get(current, 'fields.isHeader', false)) {
        const rateplanType = _.get(current, 'fields.rateplanType', '');
        const devicesList = _.get(current, 'fields.deviceList', []).reduce(
          (deviceAcc, deviceCurrent) => {
            return {
              ...deviceAcc,
              [_.get(deviceCurrent, 'fields.deviceName', '')]: 0
            };
          },
          {}
        );
        return {
          ...acc,
          [rateplanType]: { ...acc[rateplanType], ...devicesList }
        };
      }
      return { ...acc };
    }, {});
    setHardwareModel(hardwareTotalList);
  }, []);

  useEffect(() => {
    if (hardwareModel) {
      let totalRateplanFleetTracker = 0;
      let totalRateplanAssetTracker = 0;
      let totalVideoTelematicsTracker = 0;
      let additionalServicesTotal = 0;
      let addonsTotal = 0;
      let vehiclesTotal = 0;
      const hardwareObj =
        hardwareModel &&
        Object.keys(hardwareModel).reduce((acc, currentRateplanType) => {
          const deviceList = Object.keys(
            hardwareModel[currentRateplanType]
          ).reduce(
            (deviceAcc, currentDevice) => ({
              ...deviceAcc,
              [currentDevice]: 0
            }),
            {}
          );
          return { ...acc, [currentRateplanType]: { ...deviceList } };
        }, {});
      /**
       * Calculating Rateplan total + included hardware count
       */
      Object.keys(ratePlans).forEach(plan => {
        Object.keys(ratePlans[plan]).forEach(device => {
          const ratePlanQuantity = ratePlans[plan][device].quantity || 0;
          const ratePlanType = Object.keys(hardwareObj).reduce(
            (acc, current) => {
              if (device in hardwareObj[current]) return current;
              return acc;
            },
            ''
          );
          hardwareObj[ratePlanType][device] += ratePlanQuantity;
          totalRateplanFleetTracker +=
            ratePlanType === 'Fleet Tracker' ? ratePlanQuantity : 0;
          totalRateplanAssetTracker +=
            ratePlanType === 'Asset Tracker' ? ratePlanQuantity : 0;
          totalVideoTelematicsTracker +=
            ratePlanType === 'Video Telematics' ? ratePlanQuantity : 0;
        });
      });

      /**
       * Calculating additional hardware count
       */
      Object.keys(hardware).forEach(device => {
        const ratePlanType = Object.keys(hardwareObj).reduce((acc, current) => {
          if (device in hardwareObj[current]) return current;
          return acc;
        }, '');

        if (hardwareObj[ratePlanType] && device in hardwareObj[ratePlanType]) {
          const hardwareQuantity = hardware[device].additionalQuantity || 0;
          hardwareObj[ratePlanType][device] += hardwareQuantity;
        }
      });
      /**
       * Calculating Additional Services count
       */
      if (hasAdditonalServices)
        Object.keys(additionalServices).forEach(additionalService => {
          const additionalServiceQuantity =
            additionalServices[additionalService].quantity || 0;
          additionalServicesTotal += additionalServiceQuantity;
        });
      /**
       * Calculating Addon's count
       */
      Object.keys(addons).forEach(addon => {
        const addonQuantity = addons[addon].quantity || 0;
        addonsTotal += addonQuantity;
      });
      /**
       * Calculating Vehicle Info count
       */
      vehicleInfo.forEach(info => {
        const vehicleQuantity = +info.quantity || 0;
        vehiclesTotal += vehicleQuantity;
      });

      setTracker({
        fleetTrackerRateplanTotal: totalRateplanFleetTracker,
        assetTrackerRateplanTotal: totalRateplanAssetTracker,
        videoTelematicsTracker: totalVideoTelematicsTracker,
        ...(hasAdditonalServices && { additionalServicesTotal }),
        addonsTotal,
        vehiclesTotal
      });
      setHardwareList(hardwareObj);
    }
  }, [hardwareModel, ratePlans, hardware, vehicleInfo, addons]);

  return (
    <>
      {hardwareList && (
        <SummaryContainer>
          {_.get(hardwareList, 'Fleet Tracker', '') && (
            <FleetTracker
              tracker={tracker}
              hardwareList={hardwareList['Fleet Tracker']}
            />
          )}
          {_.get(hardwareList, 'Asset Tracker', '') && (
            <AssetTracker
              tracker={tracker}
              hardwareList={_.get(hardwareList, 'Asset Tracker', {})}
            />
          )}
          {_.get(hardwareList, 'Video Telematics', '') && (
            <VideoTelematics
              tracker={tracker}
              hardwareList={_.get(hardwareList, 'Video Telematics', {})}
            />
          )}
        </SummaryContainer>
      )}
    </>
  );
};

SummaryTracker.propTypes = {
  rateplanList: PropTypes.objectOf(PropTypes.any).isRequired,
  ratePlans: PropTypes.objectOf(PropTypes.object).isRequired,
  hasAdditonalServices: PropTypes.objectOf(PropTypes.object).isRequired,
  additionalServices: PropTypes.objectOf(PropTypes.object).isRequired,
  addons: PropTypes.objectOf(PropTypes.object).isRequired,
  hardware: PropTypes.objectOf(PropTypes.object).isRequired,
  vehicleInfo: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default SummaryTracker;
